//对账状态
export const makeInvoiceArr = [{
     value: 0,
     label: '未确认'
}, {
     value: 1,
     label: '已确认'
}];
//开票状态
export const settlementArr = [{
     value: 0,
     label: '未开票'
}, {
     value: 1,
     label: '已开票'
}];